// --- Types ---

export interface ChartDataPoint {
    date: string;
    value: number;
}

export interface ShareCardMeta {
    cardType: "lp-volume" | "earnings" | "positions" | "distributions" | "apy";
    delta: string;
    deltaPeriod: string;
}

export interface ChartConfig {
    title: string;
    data: ChartDataPoint[];
    kpiValue: number;
    formatter: (value: number) => string;
}

// --- Card type mapping (title → share card type) ---

export const CARD_TYPE_MAP: Record<string, ShareCardMeta["cardType"]> = {
    "LP Volume (Cumulative)": "lp-volume",
    "LP Earnings (Cumulative)": "earnings",
    "Total Positions Using YaaS": "positions",
    "YaaS Distributions (Cumulative)": "distributions",
    "YaaS APY": "apy"
};
